import { AddFamilyMemberRequest, FamilyMember } from "@/types/familyTypes";
import api from "@/api/axios";
import { ApiResponse } from "@/types/apiResponse";

export async function fetchFamilyMembers() {
  const res = await api.get<ApiResponse<FamilyMember[]>>("/family");

  return res.data.data;
}

export async function fetchStoreFamilyMember(request: AddFamilyMemberRequest) {
  const res = await api.post<ApiResponse<FamilyMember>>("/family", request);

  return res.data.data;
}

export async function fetchUpdateFamilyMember(
  request: AddFamilyMemberRequest,
  memberId: number
) {
  const res = await api.put<ApiResponse<FamilyMember>>(
    `/family/${memberId}`,
    request
  );

  return res.data.data;
}

export async function fetchDeleteFamilyMember(memberId: number) {
  return await api.delete<void>(`/family/${memberId}`);
}
